<template>
  <draggable
    class="question-sort"
    :list="possibleAnswers"
    :disabled="disabled"
  >
    <div v-for="(answer, index) in possibleAnswers"
      :key="answer.id"
      class="question-sort__answer"
      :class="{ 'question-sort__answer--disabled': disabled }"
    >
      <v-icon class="question-sort__icon">mdi-drag</v-icon>
      <span>{{ index + 1 }}. {{ answer.title }}</span>
    </div>
  </draggable>
</template>

<script>
import draggable from 'vuedraggable';

export default {
  components: {
    draggable,
  },

  props: {
    id: {
      type: Number,
      required: true,
    },
    parameters: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      possibleAnswers: [],
    };
  },

  watch: {
    possibleAnswers() {
      const formattedAnswer = {
        question_id: this.id,
        value: {
          possible_answer_ids: this.possibleAnswers.map(
            (answer) => answer.id,
          ),
        },
      };

      this.$emit('input', formattedAnswer);
    },
  },

  created() {
    if (this.parameters.currentAnswer) {
      const answersList = this.parameters.possibleAnswers;
      const answersOrder = this.parameters.currentAnswer;
      this.possibleAnswers = answersOrder.map(
        (answerId) => answersList.find((answer) => answer.id === answerId),
      );
    } else {
      this.possibleAnswers = this.parameters.possibleAnswers;
    }
  },
};
</script>

<style lang="scss" scoped>
.question-sort {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;

  &__answer {
    background: #FCFCFC;
    border: 1px solid #E2E6EA;
    color: $main--text;
    flex: 0 0 calc(50% - 8px);
    width: 50%;
    margin-bottom: 16px;
    min-height: 50px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    font-size: 12px;
    line-height: 14px;
    padding: 0 16px 0 8px;
    cursor: pointer;

    &--disabled {
      cursor: default;
    }
  }

  &__icon {
    padding-right: 8px;
  }
}
</style>
